import React, {useState} from 'react';
import {Button, Modal, Space, Typography} from 'antd';
import {useTranslation} from 'react-i18next';
import api from '../api';
import {handleApiError} from '../helpers/formatApiError';

export default function MetadataEntitySchemaOrder({type, onChanged}) {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);
    const [fields, setFields] = useState([]);
    const [busy, setBusy] = useState(false);
    const move = (index, offset) => {
        const next = [...fields];
        [next[index], next[index + offset]] = [next[index + offset], next[index]];
        setFields(next);
    };
    const save = () => {
        setBusy(true);
        api.put(`/api/metadata_entity_types/${type.id}`, {metadata_entity_type: {}, field_order: fields.map(field => field.key)})
            .then(() => {setOpen(false); onChanged();}).catch(handleApiError).finally(() => setBusy(false));
    };
    return <>
        <Button size="small" onClick={() => {setFields(type.schema_fields || []); setOpen(true);}}>{t('reorder-fields', 'Reorder fields')}</Button>
        <Modal title={t('reorder-fields', 'Reorder fields')} open={open} onCancel={() => setOpen(false)} onOk={save} confirmLoading={busy}>
            <Space direction="vertical" style={{width: '100%'}}>{fields.map((field, index) => <Space key={field.key}>
                <Typography.Text>{field.name}</Typography.Text>
                <Button disabled={index === 0} onClick={() => move(index, -1)}>{t('move-up', 'Move up')}</Button>
                <Button disabled={index === fields.length - 1} onClick={() => move(index, 1)}>{t('move-down', 'Move down')}</Button>
            </Space>)}</Space>
        </Modal>
    </>;
}
